import styled from '@emotion/styled';

export const FooterContainer = styled.footer`
  width: 100%;
  color: var(--white);
  text-align: center;
  position: absolute;
  bottom: 0px;
  margin: 12px 0;
  font-family: 'simpleStamp', sans-serif;
  font-size: 12px;
  opacity: 0.5;
`;
